import React from 'react'
import { GridForm, TrackedButton } from '@flock/shared-ui'
import {
  Box,
  IconButton,
  Modal,
  Paper,
  styled,
  Typography,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { WebinarModalProps } from './WebinarModalTypes'

const ModalWrapper = styled(Paper)({
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '500px',
  width: '70%',
  maxHeight: '75vh',
  overflowY: 'auto',
  padding: '48px',
  borderRadius: '24px',
})

const WebinarModalTablet = (props: WebinarModalProps) => {
  const {
    inputConfigs,
    onSubmit,
    loading,
    webinarModalOpen,
    setWebinarModalOpen,
  } = props

  const onClose = () => {
    setWebinarModalOpen(false)
  }

  return (
    <Box>
      <Modal open={webinarModalOpen} onClose={onClose}>
        <ModalWrapper>
          <Box position="fixed" top="16px" right="16px">
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
          <Box display="flex" flexDirection="column" gap="16px">
            <Typography variant="h3" color="moneyGreen.main">
              Watch Flock&apos;s Webinar
            </Typography>
            <GridForm
              onSubmit={onSubmit}
              inputConfigs={inputConfigs}
              loading={loading}
              ctaBoxProps={{
                width: '114px',
                alignSelf: 'flex-end',
                whiteSpace: 'nowrap',
              }}
              ctaButtonProps={{
                sx: {
                  width: 'auto!important',
                },
              }}
              gridProps={{
                spacing: 3,
              }}
              ctaText="Watch Now"
            />
          </Box>
        </ModalWrapper>
      </Modal>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="4px"
        justifyContent="flex-end"
      >
        <Typography variant="p1">Want more information?</Typography>{' '}
        <TrackedButton
          variant="text"
          onClick={() => setWebinarModalOpen(true)}
          disableTouchRipple
          sx={{ fontSize: '20px!important' }}
          trackingConfig={{
            properties: {
              leadConversion: 'started',
              webinarCta: true,
            },
          }}
        >
          Watch our most recent live webinar.
        </TrackedButton>
      </Box>
    </Box>
  )
}

export default WebinarModalTablet
